const validateDisplayName = (value) => /\p{L}/u.test(value.trim()); // \p{L} matches any Unicode letter

// Note: Horizon also implements this in app/main/csvProcessing/validateUserImportCSV.js — keep them in sync.
const toUsernameSegment = (value) =>
	value
		.normalize("NFD") // decompose accented chars so é → e + combining mark; combining mark is then stripped below
		.replaceAll(" ", ".")
		.toLowerCase()
		.replace(/[^a-z0-9\-.]/gi, ""); // strips combining marks and any other non-username chars

export { validateDisplayName, toUsernameSegment };
